import { create } from 'zustand';

import { settingsApi } from '@/lib/api/settings.api';

interface FeaturesState {
  chatbot: boolean;
  humanReview: boolean;
  humanReviewDataField: string;
  gcpCosts: boolean;
  twilioCosts: boolean;
  smsActionsModule: boolean;
  reports: boolean;
  webhooks: boolean;
  paymentLinks: boolean;
  dealerKit: boolean;
  stockSync: boolean;
  serviceHistory: boolean;
  messaging: boolean;
  bookings: boolean;
  financeApplications: boolean;
  digitalSign: boolean;
  agentImprovement: boolean;
  compareKpis: boolean;
  analyticsReporter: boolean;
  clientsView: boolean;
  isLoaded: boolean;
  loadFeatures: () => Promise<void>;
}

export const useFeaturesStore = create<FeaturesState>()((set) => ({
  chatbot: false,
  humanReview: false,
  humanReviewDataField: 'availability_data',
  gcpCosts: false,
  twilioCosts: false,
  smsActionsModule: false,
  reports: false,
  webhooks: false,
  paymentLinks: false,
  dealerKit: false,
  stockSync: false,
  serviceHistory: false,
  messaging: false,
  // Live for clients today — default on unless explicitly disabled
  bookings: true,
  financeApplications: true,
  digitalSign: true,
  agentImprovement: false,
  compareKpis: false,
  analyticsReporter: false,
  clientsView: false,
  isLoaded: false,

  loadFeatures: async () => {
    try {
      const features = await settingsApi.getFeatures();

      set({
        chatbot: !!features.FEATURE_CHATBOT,
        humanReview: !!features.FEATURE_HUMAN_REVIEW,
        humanReviewDataField: (features.HUMAN_REVIEW_DATA_FIELD as string) || 'availability_data',
        gcpCosts: !!features.FEATURE_GCP_COSTS,
        twilioCosts: !!features.FEATURE_TWILIO_COSTS,
        smsActionsModule: !!features.FEATURE_SMS_ACTIONS_MODULE,
        reports: !!features.FEATURE_REPORTS,
        webhooks: !!features.FEATURE_WEBHOOKS,
        paymentLinks: !!features.FEATURE_PAYMENT_LINKS,
        dealerKit: !!features.FEATURE_DEALER_KIT,
        stockSync: !!features.FEATURE_STOCK_SYNC,
        serviceHistory: !!features.FEATURE_SERVICE_HISTORY,
        messaging: !!features.FEATURE_MESSAGING,
        // Default on unless explicitly disabled (live for clients today)
        bookings: features.FEATURE_BOOKINGS !== false,
        financeApplications: features.FEATURE_FINANCE_APPLICATIONS !== false,
        digitalSign: features.FEATURE_DIGITAL_SIGN !== false,
        agentImprovement: !!features.AGENT_IMPROVEMENT_ENABLED,
        compareKpis: !!features.FEATURE_COMPARE_KPIS,
        analyticsReporter: !!features.FEATURE_ANALYTICS_REPORTER,
        clientsView: !!features.FEATURE_CLIENTS_VIEW,
        isLoaded: true,
      });
    } catch {
      // Feature fetch is non-critical — keep defaults (disabled)
      set({ isLoaded: true });
    }
  },
}));
